class DetailsDropdown extends HTMLElement {
    constructor() {
        super();
        this._detailsDropdown = this.querySelector('[detailsDropdown]');
        this._detailsSummary = this.querySelector('[detailsDropdown] summary');
        this._detailsBody = this.querySelector('[detailsBody]');
        this._animatinItems = this.querySelector('[animation-item]');
        this._animationType = this.querySelector('[animation-type]').getAttribute('animation-type') || 'fade-down';


        this._debouncedOpenDropdown = HELPER_UTIL.debounce(this.opendDropdown.bind(this), 150);
        this._debouncedCloseDropdown = HELPER_UTIL.debounce(this.closeDropdown.bind(this), 150);

        this._detailsDropdown.addEventListener(
            'mouseenter',
            this._debouncedOpenDropdown
        );
        this._detailsDropdown.addEventListener(
            'mouseleave',
            this._debouncedCloseDropdown
        );

        if (this._detailsDropdown.hasAttribute('open')) {
            this.activeDetailsDropdown();
        }

        if (window.matchMedia("(max-width: 991px)").matches) {
            this._detailsSummary.addEventListener('touchstart', (e) => {
                e.preventDefault();
                e.stopPropagation();

                document.querySelectorAll('details-dropdown').forEach((el) => {
                    if (el !== this && el._detailsDropdown && el._detailsDropdown.hasAttribute('open')) {
                        el.inActiveDetailsDropdown(el._detailsBody, el._detailsDropdown);
                    }
                });

                if (!this._detailsDropdown.hasAttribute('open')) {
                    this.activeDetailsDropdown();
                } else {
                    this.inActiveDetailsDropdown(this._detailsBody, this._detailsDropdown);
                }
            });

        }
    }

    animateDetailsDropdownOnOpen() {
        if (this._animationType === "fade-up") {
            Motion.animate(this._animatinItems, { opacity: [0, 1], y: [20, 0] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" })
        } else {
            Motion.animate(this._animatinItems, { opacity: [0, 1], y: [-20, 0] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" })

        }
    }

    animateDetailsDropdownOnClose(dropdownBody, dropdownDetails) {
        const animationItem = dropdownBody.querySelector('[animation-item]')
        const animationType = dropdownDetails.querySelector('[animation-type]').getAttribute('animation-type') || 'fade-down'
        if (animationType === "fade-up") {
            Motion.animate(animationItem, { opacity: [1, 0], y: [0, 20] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" }).finished.then(() => {
                dropdownDetails.removeAttribute("open")
            })
        } else {
            Motion.animate(animationItem, { opacity: [1, 0], y: [0, -20] }, { duration: 0.3, ease: "cubic-bezier(.75,0,.175,1)" }).finished.then(() => {
                dropdownDetails.removeAttribute("open")
            })
        }

    }

    inActiveDetailsDropdown(dropdownBody, dropdownDetails) {
        dropdownBody.classList.remove('active');
        dropdownDetails.setAttribute("aria-expanded", "false")
        this.animateDetailsDropdownOnClose(dropdownBody, dropdownDetails)
    }

    activeDetailsDropdown() {
        this._detailsBody.classList.add('active');
        this._detailsDropdown.setAttribute("open", "true")
        this._detailsDropdown.setAttribute("aria-expanded", "true")
        window.requestAnimationFrame(() => {
            this.animateDetailsDropdownOnOpen()
        })
    }



    opendDropdown(e) {

        e.preventDefault();
        if (this._detailsBody.classList.contains('active')) return
        this._detailsDropdown.classList.add('active');

        this._allDropdowns = document.querySelectorAll('[detailsDropdown][open="true"]');
        this._allDropdowns && this._allDropdowns.forEach((dropdown) => {
            const dropdownBody = dropdown.querySelector('[detailsBody]')
            const dropdownDetails = dropdown
            this.inActiveDetailsDropdown(dropdownBody, dropdownDetails)
        }
        )
        this.activeDetailsDropdown();
    }

    closeDropdown(e) {
        e.preventDefault();
        if (this._detailsBody.classList.contains('active')) {
            this.inActiveDetailsDropdown(this._detailsBody, this._detailsDropdown);
            this._detailsDropdown.classList.remove('active');
        }
    }
    connectedCallback() {
    }
}

customElements.define('details-dropdown', DetailsDropdown);